import { gql } from "@apollo/client";

const MessagingServices = gql`
  query {
    messagingServices {
      value
      isDefault
      label
      icon
    }
  }
`;

export { MessagingServices };
